<div class="collapsible" [ngClass]="{'collapsible--inclusive': inclusive, 'collapsible--custom-header': customHeader, 'collapsible--collapsed': !expanded}">
  <div class="collapsible__header" (click)="toggle()">
    <div class="d-flex align-items-center">
      <div class="collapsible__index semi-bold dark small" *ngIf="index">{{index}}</div>
      <p class="collapsible__title text-medium semi-bold" *ngIf="title">{{title}}</p>
    </div>

    <ng-content select="[headerContent]"></ng-content>
    <div class="collapsible__icon">
      <img *ngIf="expanded" src="/assets/icons/minimal_arrow_up.svg">
      <img *ngIf="!expanded" src="/assets/icons/minimal_arrow_up_grey.svg">
    </div>
  </div>
  <ng-content select="[visibleContent]"></ng-content>
  <div class="collapsible__content"
     [@collapse]="
        {
          value: (expanded ? 'expanded' : 'collapsed')
        }
      "
  >
    <ng-content select="[hiddenContent]"></ng-content>
  </div>
</div>
